/**
 * Created by sasik on 6/13/16.
 */
/**
 * dynamic loading product properties when category was change
 * @type {{getPlaceholder: ProductProperties.getPlaceholder, getProperties: ProductProperties.getProperties}}
 */
var ProductProperties = {
    getPlaceholder : function(language) {
        return $('.js_properties_placeholder[data-language=' + language + ']');
    },

    getProperties : function (categoryId,ProductId) {
        $.ajax({
            url: '/frontend/api/product/properties/' + categoryId,
            data : {
                _token: Sasik.getToken(),
                'product_id':ProductId
            },
            success: function (data) {

                var view = data.view;
                for (var language in view) {
                    // console.log(view[language]);
                    var placeholder = ProductProperties.getPlaceholder(language);
                    placeholder.empty();
                    placeholder.append(view[language]);
                }

                $(".floor-plan-field").each(function(i,item){
                    if(item.floorplan)
                        return;
                    item.floorplan=new FloorPlanField(item);
                });

                $(".multiimages").each(function(i,item){
                    if(item.multi)
                        return;
                    item.multi = new MultiImages(item);
                    return;
                    item.multi = new MultiImages(item);

                });

                $(".vrproperty").each(function(i,item){
                    if(item.vrp)
                        return;
                    item.vrp = new VRProperty(item);

                });

                workTimeCheck();

                //textarea append
                SetupTextArea();

                UpdateEanCodeExample();
                CurrentCategoryId = categoryId;
                console.log("Events try", data);
                GlobalManager.trigger('ajax_change_url',data.base_url);
            }
        });
    }
};